<template>
	<div class="bg-main">
		<v-container>
			<v-row align="start" justify="start">
				<v-col cols="3">
					<v-subheader>Em breve...</v-subheader>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
	export default {
		name: "Servico"
	}
</script>

<style scoped>

</style>
